import { render, staticRenderFns } from "./UnitInsure.vue?vue&type=template&id=33dfbe4c&scoped=true"
import script from "./UnitInsure.vue?vue&type=script&lang=js"
export * from "./UnitInsure.vue?vue&type=script&lang=js"
import style0 from "./UnitInsure.vue?vue&type=style&index=0&id=33dfbe4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.11_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dfbe4c",
  null
  
)

export default component.exports